import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export function lucideIconByName(name: string | null | undefined): LucideIcon | undefined {
  if (!name) return undefined;
  return (LucideIcons as unknown as Record<string, LucideIcon>)[name];
}
